import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { CertificationDto } from "@/core/features/certifications/certification.dto";
import { DossierDto } from "@/core/features/dossiers/dtos/dossier.dto";
import { ValuationHasProjectDto } from "@/core/features/valuations/valuation-has-project.dto";
import { UserDto } from "@/core/features/users/user.dto";
import { parseApiDate } from "@/utils/dates/dateFormats";
import { getValuationMonthLabel } from "@/modules/valuations/utils/valuation-month.utils";
import { toEuros } from "@/utils/numberUtils";
import { Transform, Type } from "class-transformer";
import { ValuationStatusEnum } from "@altertec_gparn/lib";

export class ValuationDto extends BaseEntityDto {
  code: string;

  @Type(() => DossierDto)
  dossier: DossierDto;
  dossierId: string;

  @Type(() => CertificationDto)
  certification?: CertificationDto;
  certificationId?: string;

  @Type(() => UserDto)
  responsibleUser: UserDto;
  responsibleUserId: string;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  startDate: Date;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  endDate: Date;

  @Transform(({ value }) => toEuros(value, false))
  executedAmount: number;

  status: ValuationStatusEnum;

  @Transform(({ value }) => (value ? parseApiDate(value) : null))
  registrationDate?: Date;

  notes?: string | null;

  @Type(() => ValuationHasProjectDto)
  valuationHasProjects: ValuationHasProjectDto[];

  toString(): string {
    return this.code ?? `${this.dossier?.code ?? this.dossierId} (${getValuationMonthLabel(this.startDate)})`;
  }

  isClosed(): boolean {
    return this.status === ValuationStatusEnum.CLOSED;
  }

  isInProgress(): boolean {
    return this.status === ValuationStatusEnum.IN_PROGRESS;
  }

  isCertified(): boolean {
    return !!this.certificationId;
  }

  isEditable(): boolean {
    return this.isInProgress() && !this.isCertified();
  }
}
